import { Controller } from "@hotwired/stimulus";
import FavoritesService from "../utilities/favorites_service";

export default class extends Controller {
  static values = { productId: Number };

  connect() {
    this._updateDisplay();
  }

  toggle() {
    FavoritesService.toggle(this.productIdValue);
    this._updateDisplay();
  }

  _updateDisplay() {
    var favorited = FavoritesService.isFavorited(this.productIdValue);
    this.element.classList.toggle('on', favorited);
    this.element.classList.toggle('off', !favorited);
    this.element.title = favorited
      ? 'Click to remove this product from your favorites'
      : 'Click to add this product to your favorites';
  }
}
